import React from 'react';
import Spinner from '../spinner/Spinner';

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  label: string;
  backgroundColor?: string;
  onClick?: any;
  disabled?: boolean;
  size?: 'small' | 'medium' | 'large';
  variant?: 'primary' | 'secondary' | 'outlined' | 'destructive';
  isLoading?: boolean;
  fullWidth?: boolean;
  icon?: React.ReactNode;
  className?: string;
  iconPosition?: 'beforeText' | 'afterText';
}

export const Button = ({
  label,
  onClick = () => {},
  disabled = false,
  size = 'small',
  isLoading,
  fullWidth,
  variant = 'primary',
  icon,
  iconPosition = 'beforeText',
  className = '',
  ...rest
}: ButtonProps) => {
  const variantClasses = {
    primary: disabled ? 'bg-gray-300 text-white' : 'bg-primary text-white',
    secondary: disabled
      ? 'bg-gray-200 text-gray-500'
      : 'bg-secondary text-white',
    outlined: disabled
      ? 'border border-gray-300 text-gray-400 bg-transparent'
      : 'border border-primary text-primary bg-transparent',
    destructive: disabled
      ? 'bg-red-200 text-red-400'
      : 'bg-red-600 text-white hover:bg-red-700',
  };

  return (
    <button
      {...rest}
      type="submit"
      disabled={isLoading || disabled}
      aria-label="button"
      onClick={onClick}
      className={`
        flex items-center justify-center gap-2 px-4 rounded focus:outline-none
        ${size === 'small' ? 'h-10 text-sm' : 'h-12 text-base'}
        ${fullWidth ? 'w-full' : ''}
        ${variantClasses[variant]}
        ${isLoading || disabled ? 'cursor-not-allowed' : 'cursor-pointer'}
        ${className}
      `}
    >
      {!isLoading && icon && iconPosition === 'beforeText' && (
        <div className="my-auto">{icon}</div>
      )}

      {isLoading && <Spinner />}
      {!isLoading && <span>{label}</span>}

      {!isLoading && icon && iconPosition === 'afterText' && (
        <div className="my-auto">{icon}</div>
      )}
    </button>
  );
};
